import { useState } from "react";
import React from "react";
import { Document, Page } from "react-pdf";
import { useParams } from "react-router-dom";
import { pdfjs } from "react-pdf";
import "../styles/Viewer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = () => {
  const { file } = useParams();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1.0); // Default zoom level

  const onDocumentLoadSuccess = ({ numPages }) => {
    if (typeof numPages === "number" && numPages > 0) {
      setNumPages(numPages);
      setPageNumber(1);
    } else {
      console.error("Invalid number of pages:", numPages);
    }
  };

  const goToPrevPage = () => {
    setPageNumber((prev) => {
      const newPage = Math.max(prev - 1, 1);
      if (newPage === prev) console.warn("Already at the first page.");
      return newPage;
    });
  };

  const goToNextPage = () => {
    setPageNumber((prev) => {
      const newPage = Math.min(prev + 1, numPages);
      if (newPage === prev) console.warn("Already at the last page.");
      return newPage;
    });
  };

  const zoomIn = () => {
    setZoom((prevZoom) => {
      const newZoom = Math.min(prevZoom + 0.2, 3.0);
      if (newZoom === prevZoom) console.warn("Maximum zoom level reached.");
      return newZoom;
    });
  };

  const zoomOut = () => {
    setZoom((prevZoom) => {
      const newZoom = Math.max(prevZoom - 0.2, 0.5);
      if (newZoom === prevZoom) console.warn("Minimum zoom level reached.");
      return newZoom;
    });
  };

  const handleZoomChange = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value >= 50 && value <= 300) {
      setZoom(value / 100);
    } else {
      console.error("Zoom value must be between 50 and 300 percent.");
    }
  };

  const handlePageChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1 && value <= numPages) {
      setPageNumber(value);
    } else {
      console.error(`Page number must be between 1 and ${numPages}.`);
    }
  };

  return (
    <div className="pdf-viewer-container">
      <div className="controls">
        <div className="zoom-controls">
          <div className="zoom-container">
            <button onClick={zoomOut} disabled={zoom <= 0.5}>
              -
            </button>
            <input
              type="number"
              value={Math.round(zoom * 80)} // Pure number, e.g., 100
              onChange={handleZoomChange}
              min="50"
              max="300"
              step="10"
              className="control-input"
            />
            <span>%</span>

            <button onClick={zoomIn} disabled={zoom >= 3.0}>
              +
            </button>
          </div>
          <p>
            {"  "}|{"  "}
          </p>
          <div className="page-number-container">
            <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
              -
            </button>
            <input
              type="number"
              value={pageNumber}
              onChange={handlePageChange}
              min="1"
              max={numPages}
              className="control-input"
            />
            <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
              +
            </button>
          </div>
        </div>
      </div>
      {/* PDF document */}
      <div className="pdf-view">
        <Document
          file={`/Articles/${file}`}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <div className="pdf-scroll-container" key={pageNumber}>
            <div className="pdf-page">
              <Page pageNumber={pageNumber} scale={zoom} />
            </div>
          </div>
          {pageNumber < numPages && (
            <div
              style={{
                visibility: "hidden",
                height: 0,
                overflow: "hidden",
                position: "absolute",
              }}
            >
              <Page
                pageNumber={pageNumber + 1}
                scale={zoom}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </div>
          )}
        </Document>
      </div>
      {/* Controls below PDF */}
    </div>
  );
};

export default PDFViewer;
